import VueMq from 'vue-mq';
import VueDataTables from 'vue-data-tables';

// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import * as VueGoogleMaps from 'vue2-google-maps';
import VueUploadComponent from 'vue-upload-component';
import moment from 'moment';
import Vue from 'vue';
import VueClipboards from 'vue-clipboards';
import VueTour from 'vue-tour';
import { datadogRum } from '@datadog/browser-rum';
import PrismicVue from '@prismicio/vue';
import Pusher from 'pusher-js';
import App from './App.vue';
import router from './router';
import store from './store/index';
import './plugins/element';
import './styles/_fa-override.scss';
import { httpAuth, httpNoAuth } from './utils/axios-utils';
import FontAwesomeIcon from './components/common/FontAwesome.vue';

import './plugins/fas-lib';

// Use your repository name
const endpoint = 'https://assemble-documentations.prismic.io/api/v2';

require('vue-tour/dist/vue-tour.css');

Vue.use(VueTour);
Vue.use(PrismicVue, {
  endpoint,
  apiOptions: {},
});

if (process.env.VUE_APP_DD_APP_ID) {
  datadogRum.init({
    applicationId: process.env.VUE_APP_DD_APP_ID,
    clientToken: process.env.VUE_APP_DD_APP_KEY,
    site: 'datadoghq.com',
    service: 'assemble-admin',
    env: process.env.VUE_APP_DD_ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    version: process.env.DATADOG_VERSION,
    sampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: 'allow'
  });

  datadogRum.startSessionReplayRecording();
}

Vue.use(VueClipboards);
Vue.component('fa-icon', FontAwesomeIcon);
Vue.component('el-input-title', () => import('./components/elements/ElInputTitle.vue'));
Vue.component('page-header', () => import('./components/common/PageHeader.vue'));
Vue.component('vue-upload-component', VueUploadComponent);

Vue.use(VueMq, {
  breakpoints: {
    sm: 450,
    md: 1024,
    lg: Infinity,
  },
});

Vue.use(VueDataTables);
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyAPIJ-9AuUJDulNAPUZCYqXdjpVavxoj8g',
//     libraries: 'places',
//   }
// });

Vue.component('el-loading-circle', () => import('./components/elements/ElLoadingCircle.vue'));
Vue.component('el-date-input', () => import('./components/elements/ElDateInput.vue'));
Vue.component('el-price-input', () => import('./components/elements/ElPriceInput.vue'));
Vue.component('el-price-input-v2', () => import('./components/elements/ElPriceInputV2.vue'));
Vue.component('el-percentage-input', () => import('./components/elements/ElPercentageInput.vue'));
Vue.component('el-checkbox-custom', () => import('./components/elements/ElCheckboxCustom.vue'));
Vue.component('el-time-picker-custom', () => import('./components/elements/ElTimePickerCustom.vue'));

Vue.component('google-auto-complete', () => import('./components/VueGoogleAutocomplete.vue'));

Vue.config.productionTip = false;

// Vue Prototypes
Vue.prototype.$httpNoAuth = httpNoAuth;
Vue.prototype.$http = httpAuth;
Vue.prototype.$pusher = new Pusher(
  process.env.VUE_APP_PUSHER_API_KEY,
  {
    cluster: 'ap4',
  }
);
Vue.prototype.moment = moment;

// Vue google map custom
Vue.prototype.$gmapApiPromiseLazy = () => new Promise((resolve) => resolve());
Vue.prototype.$gmapOptions = { autobindAllEvents: false };

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
